import { isSignInWithEmailLink } from "firebase/auth";
import { useCallback } from "react";
import { Navigate, useNavigate } from "react-router-dom-v5-compat";

import { getFirebaseAuth } from "services/firebase/auth";

import { userAccountType } from "features/user";
import { ROUTES } from "routing/routes";

import SignInViaLink from "../SignInViaLink";

export default function SignInParentViaLinkRoute() {
  const auth = getFirebaseAuth();
  const isValidSignInUrl = isSignInWithEmailLink(auth, window.location.href);

  const navigate = useNavigate();

  const navigateToUserDetails = useCallback(() => {
    navigate(ROUTES.SIGN_UP_PARENT.USER_DETAILS.buildPath({}), {
      state: ROUTES.SIGN_UP_PARENT.USER_DETAILS.buildState({
        showMarketingEmailsCheckbox: true
      })
    });
  }, [navigate]);

  const navigateToHomepage = useCallback(() => {
    navigate(ROUTES.PARENT.buildPath({}));
  }, [navigate]);

  if (!isValidSignInUrl) {
    return <Navigate to={ROUTES.SIGN_UP_PARENT.buildPath({})} />;
  }

  const onError = (errorMessage: string) =>
    navigate(ROUTES.SIGN_UP_PARENT.buildPath({}), {
      state: ROUTES.SIGN_UP_PARENT.buildState({ errorMessage })
    });

  return (
    <SignInViaLink
      onSignInSuccess={navigateToHomepage}
      onSignUpSuccess={navigateToUserDetails}
      userAccountType={userAccountType.schoolparent}
      onError={onError}
    />
  );
}
